import React from "react";
import { convertS3UrlToGcp } from "src/modules/worksheet/views/edit_enhanced/helpers";

const ImageComponent = ({ imageObj }) => {
    const { src } = imageObj;
    return (
        <div className="renderer-table-image-wrapper">
            <div className="renderer-table-image-item">
                <img
                    width="50px"
                    style={{
                        maxWidth: "100%",
                        height: "auto",
                    }}
                    src={convertS3UrlToGcp(src?.default ?? src?.value)}
                    alt=""
                />
            </div>
        </div>
    );
};

export default ImageComponent;
